import { environmentDev } from "./environment-dev";
import { environmentProd } from "./environment-prod";
export var environment = process.env["STAGE_NAME"] === "production" ? environmentProd : environmentDev;
